<template lang="html">
    <div class="px-4">
<!--        <div class="vx-row">-->
<!--            <div class="col vx-card p-3">-->
<!--                <div class="vx-row">-->
<!--                    <div class="vx-col md:w-8/12 w-full flex" style="font-size: 17px; font-weight: 500">-->
<!--                        <feather-icon icon="BookIcon" class="text-primary" style="vertical-align: middle">-->
<!--                        </feather-icon>-->
<!--                        <span class="mt-2 ml-2 text-primary">{{ policyName }}</span>-->
<!--                    </div>-->
<!--                    <div class="vx-col md:w-4/12 w-full">-->
<!--                        <div class="flex flex-wrap items-center justify-end">-->
<!--                            <vs-button type="border" color="warning" @click="buttonBack">Quay lại-->
<!--                            </vs-button>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
        <div class="vx-row">
            <div class="vx-col md:w-9/12 w-full p-0 pr-2">
                <div class="vx-card p-6" style="min-height: 310px">
                    <vs-table stripe class="mt-4" max-items="10" pagination :data="users"
                        :noDataText="'Không có dữ liệu'" :key="users">
                        <template slot="thead">
                            <vs-th class="text-primary fontMb">
                                ID
                            </vs-th>
                            <vs-th class="text-primary fontMb">
                                Tên nhân viên
                            </vs-th>
                            <vs-th class="text-primary fontMb">
                                Lý do
                            </vs-th>
                            <vs-th class="text-primary fontMb">
                                Thời gian nghỉ
                            </vs-th>

                            <vs-th class="text-primary fontMb">
                                Tên ca
                            </vs-th>

                            <vs-th class="text-primary fontMb text-center" style="text-align: center">
                                Thời gian làm việc
                            </vs-th>

                            <!--                                <vs-th class="text-primary fontMb">-->
                            <!--                                    Ca nghỉ-->
                            <!--                                </vs-th>-->
                            <vs-th class="text-primary fontMb">
                                Trạng thái
                            </vs-th>
                            <vs-th class="text-primary fontMb">
                                Người duyệt
                            </vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <vs-tr :key="tr.index" v-for="(tr, indextr) in data">
                                <vs-td :data="data[indextr].index">
                                    {{ tr.index }}
                                </vs-td>

                                <vs-td :data="data[indextr].fullName" style="min-width: 172px!important;">
                                    {{ data[indextr].fullName }}
                                </vs-td>

                                <vs-td :data="data[indextr].reason" style="min-width: 120px!important;">
                                    <div class="vx-col">
                                        <div class="vx-row bsty">
                                            {{ data[indextr].reason }}
                                        </div>
                                        <div class="vx-row twentText" v-if="data[indextr].leaveType == 1">
                                            Nghỉ không lương
                                        </div>
                                        <div class="vx-row twentText" v-if="data[indextr].leaveType == 0">
                                            Nghỉ có lương
                                        </div>
                                    </div>

                                </vs-td>

                                <vs-td v-if="data[indextr].detailNameWorkShift !== 'Cả ngày'"
                                    :data="data[indextr].displayLeaveDate">
                                    <div class="vx-row " style="min-width: 198px!important;">
                                        <feather-icon icon="CalendarIcon" class="vx-col mt-2 stdate"
                                            style="width: 28px;height: 28px;color: white;"></feather-icon>
                                        <div class="vx-col">
                                            <div class="vx-col bsty "> {{ data[indextr].fromDate }} - {{
                                                    data[indextr].toDate
                                            }}</div>
                                            <div class="vx-col twentText"> {{ data[indextr].fromHour }} - {{
                                                    data[indextr].toHour
                                            }}</div>
                                        </div>
                                    </div>
                                </vs-td>

                                <vs-td v-if="data[indextr].detailNameWorkShift == 'Cả ngày'"
                                    :data="data[indextr].displayLeaveDate">
                                    <div class="vx-row" style="min-width: 198px!important;">
                                        <feather-icon icon="CalendarIcon" class=" mt-2 stdate"
                                            style="width: 28px;height: 28px;color: white;"></feather-icon>
                                        <div class="vx-col">
                                            <div class="vx-col bsty mt-3">{{ data[indextr].fromDate }} - {{
                                                    data[indextr].toDate
                                            }}</div>
                                        </div>
                                    </div>
                                </vs-td>

                                <vs-td v-if="data[indextr].nameWorkShift !== null" :data="data[indextr].nameWorkShift"
                                    style="font-size: 12px;min-width: 85px!important;">
                                    {{ data[indextr].nameWorkShift }}
                                </vs-td>

                                <vs-td v-if="data[indextr].nameWorkShift == null" :data="data[indextr].nameWorkShift"
                                    style="font-size: 12px;min-width: 85px!important;">
                                    <div class="vx-col" :key="indexName" v-for="(ir, indexName) in allWorkShiftName">
                                        <div class="vx-row"
                                            style="font-size: 12px;min-width: 85px!important;margin-left: 0px">
                                            {{ ir }}
                                        </div>
                                    </div>
                                </vs-td>

                                <vs-td :data="data[indextr].detailNameWorkShift"
                                    style="font-size: 12px;min-width: 150px!important; ">
                                    {{ data[indextr].detailNameWorkShift }}
                                </vs-td>

                                <!--                                    <vs-td :data="data[indextr].workshiftName" style="font-size: 12px;min-width: 80px!important;">-->
                                <!--                                        {{ data[indextr].workshiftName }}-->
                                <!--                                    </vs-td>-->

                                <vs-td :data="data[indextr].status">
                                    <vs-chip v-if="data[indextr].status == 1" class="minwwt" color="success">
                                        <span>Đã duyệt</span>
                                    </vs-chip>
                                    <vs-chip v-if="data[indextr].status == 2" class="minwwt" color="danger">
                                        <span>Từ chối</span>
                                    </vs-chip>
                                    <vs-chip v-if="data[indextr].status == 0" class="minwwt" color="warning">
                                        <span>Chờ</span>
                                    </vs-chip>
                                    <vs-chip v-if="data[indextr].status == 3" class="minwwt" color="dark">
                                        <span>Hủy</span>
                                    </vs-chip>
                                </vs-td>

                                <vs-td :data="data[indextr].approveEmployeeFullName">
                                    {{ data[indextr].approveEmployeeFullName }}
                                </vs-td>

                            </vs-tr>
                        </template>
                    </vs-table>

                </div>
            </div>
            <div class="vx-col md:w-3/12 w-full p-0 pl-2">
                <div class="w-full">
                    <div class="vx-card p-4">
                        <div class="vx-row">
                            <div class="vx-col md:w-1/2 w-full mb-3 mt-3">
                                <div class=" text-primary numr">
                                    {{ countLeaveRco }}
                                </div>
                                <div class="snp">
                                    SỐ NGÀY PHÉP
                                </div>
                                <div class="tdx">
                                    Có thể tiếp tục đề xuất
                                </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full mb-3 mt-3">
                                <div class="numrl">
                                    {{ countLeave }}
                                </div>
                                <div class="snp">
                                    TẤT CẢ PHÉP ĐÃ DUYỆT
                                </div>
                                <div class="tdx">
                                    Trong {{ countDays }} ngày
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="w-full">
                    <div class="vx-card p-6 mt-4">
                        <div class="mt-2 mb-3 font-bold">
                            Chọn thời gian
                        </div>
                        <div class="vx-col" style="display: inline-block">
                            <div class="flex-grow">
                                <date-range-picker ref="picker" :locale-data="{ format: 'dd/mm/yyyy' }" :opens="'left'"
                                    @update="dateRangePicker" v-model="dateRange">
                                </date-range-picker>
                            </div>
                        </div>
                        <div>
                            <div class="mt-3 font-bold">
                                Chọn trạng thái
                            </div>
                            <div class="mt-3 mb-3">
                                <ul class="leftx">
                                    <li>
                                        <vs-radio color="warning" v-model="radios" vs-value="0">Chờ </vs-radio>
                                    </li>
                                    <li>
                                        <vs-radio color="success" v-model="radios" vs-value="1">Đã duyệt</vs-radio>
                                    </li>
                                    <li>
                                        <vs-radio color="danger" v-model="radios" vs-value="2">Từ chối</vs-radio>
                                    </li>
                                    <li>
                                        <vs-radio color="dark" v-model="radios" vs-value="3">Hủy</vs-radio>
                                    </li>
                                </ul>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import { vi } from "vuejs-datepicker/dist/locale";
import DateRangePicker from '../../../components/vue2-daterange-picker/components/DateRangePicker.vue';
import utils from "../../../components/utils";

export default {
    components: {
        DateRangePicker,
    },
    props: {
        employeeId: {
            type: Number,
            required: true,
        },
        policyNameProp: {
            type: String,
            default: '',
        },
        fullNameProp: {
            type: String,
            default: '',
        },
        organizationBranchIdProp: {
            type: Number,
        },
        organizationIdProp: {
            type: Number,
        },
    },
    watch: {
        radios(value) {
            this.getInformationLeave()
            this.getCountLeave()
            this.getCountLeaveRco()
        },
        dateRange(value) {
            this.getInformationLeave()
            this.getCountLeave()
            this.getCountLeaveRco()
        }

    },
    data: () => ({
        dateRange: {
            startDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
            endDate: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)
        },
        vi: vi,
        highlighted: {
            dates: [
                new Date()
            ]
        },
        radios: 1,
        users: [],
        displayLeaveDate: null,
        countLeave: 0,
        countLeaveRco: 0,
        checkId: null,
        policyName: null,
        fullName: null,
        organizationBranchId: null,
        organizationId: null,
        workShiftInfo: [],
        subWorkShiftName: '',
        allWorkShiftName: null,
        countDays: 0,
    }),
    methods: {
        countDateRange: function (fromDate, toDate) {
            const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
            const firstDate = new Date(fromDate);
            const secondDate = new Date(toDate);
            const diffDays = Math.round(Math.abs((firstDate - secondDate) / oneDay));
            this.countDays = diffDays;
        },
        initSrc() {
            this.loadWorkShift();
            this.checkId = this.employeeId ? this.employeeId : this.$route.query.employeeId;
            this.policyName = this.policyNameProp ? this.policyNameProp : this.$route.query.policyName;
            this.fullName = this.fullNameProp ? this.fullNameProp : this.$route.query.fullName;
            this.organizationId = this.organizationIdProp ? parseInt(this.organizationIdProp) : parseInt(this.$route.query.organizationId);
            this.organizationBranchId = this.organizationBranchIdProp ? parseInt(this.organizationBranchIdProp) : parseInt(this.$route.query.organizationBranchId);
            this.getInformationLeave()
            this.getCountLeave()
            this.getCountLeaveRco()
        },
        loadWorkShift() {
            this.$vs.loading();
            this.$crm.post(`/work-shift/employee/find-by-employee/${this.employeeId ? this.employeeId : this.$route.query.employeeId}`).then((response) => {
                this.workShiftInfo = response.data;
                let allName = response.data.workShiftSettings.map(x => {
                    return x.groupName
                })
                this.allWorkShiftName = allName
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: this.$t('message.error'),
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        formatMinuteToHours(data) {
            let hours = Math.floor(data / 60)
            let minutes = data % 60 == 0 ? '00' : data % 60;
            let result = (hours < 10 ? '0' + hours : hours) + ':' + (minutes < 10 && minutes > 0 ? '0' + minutes : minutes);
            return result;
        },
        getInformationLeave() {
            let leaveSearchDTO = {
                employeeId: this.checkId,
                organizationBranchId: this.organizationBranchId,
                organizationId: this.organizationId,
                status: this.radios,
                fromDate: this.dateRange.startDate,
                toDate: this.dateRange.endDate,
            };
            this.$vs.loading();
            this.$crm.post(`/leave/find`, leaveSearchDTO).then((response) => {
                let index = 1;
                let arr = [];
                let isTrue = false;
                this.users = response.data.map(item => {
                    item.index = index ++;
                    item.displayLeaveDate = moment(item.fromDate).format("DD/MM/YYYY") + " - " + moment(item.toDate).format("DD/MM/YYYY");
                    if (item.leaveDetails.length > 0) { item.displayLeaveDateTime = utils.minuteToHour(item.leaveDetails[0].fromHour) + " - " + utils.minuteToHour(item.leaveDetails[0].toHour); }
                    item.displayLeaveType = item.leaveType == 0 ? 'Nghỉ phép' : 'Nghỉ thường';
                    item.leaveDetails.forEach((el) => {
                        el.detailNameWorkShift = 'Cả ngày';
                        let workShiftData = this.workShiftInfo.workShiftSettings.find(p => p.id == el.workShiftId)
                        el.nameWorkShift = workShiftData ? workShiftData.groupName : null;
                        this.workShiftInfo.workShiftSettings.forEach((em) => {
                            if (isTrue == false || el.workShiftDetailsId !== null) {
                                this.subWorkShiftName = em.workShiftDetails.find(o => o.id == el.workShiftDetailsId)
                                if (this.subWorkShiftName !== undefined) {
                                    isTrue = true
                                    el.detailNameWorkShift = this.subWorkShiftName ? this.subWorkShiftName.subWorkShiftName : "";
                                }
                            } else {
                                el.detailNameWorkShift = 'Cả ngày';
                            }
                        });
                        let start = new Date(el.leaveDate).setHours(el.fromHour / 60);
                        let end = new Date(el.leaveDate).setHours(el.toHour / 60);
                        el.fromDate = moment(new Date(start)).format("DD/MM/YYYY");
                        el.toDate = moment(new Date(end)).format("DD/MM/YYYY");
                        el.fromHour = this.formatMinuteToHours(el.fromHour);
                        el.toHour = this.formatMinuteToHours(el.toHour);
                        item.leaveInfo = { ...el }
                        let object = { ...item, ...el };
                        arr.push(object);
                    })
                    if (item.leaveDetails !== null) {
                        item.displayLeaveTimes = item.leaveDetails.map(item => {
                            if (item.fromHour == 480 && item.toHour == 720) item.workshift = { value: 1, label: 'Ca sáng' };
                            else if (item.fromHour == 780 && item.toHour == 1020) item.workshift = { value: 2, label: 'Ca Chiều' };
                            else item.workshift = { value: 3, label: 'Cả ngày' };
                            return item.workshift.label;
                        })
                    } else {
                        item.displayLeaveTime = ''
                    }
                    if (item.leaveDetails !== null) {
                        item.displayLeaveTime = item.displayLeaveTimes[0]
                    }
                    if (item.status == 0) item.approveEmployeeFullName = null;
                    return item;

                });
                this.users = arr;
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        dateRangePicker: function () {
            this.dateRange.startDate = new Date(this.dateRange.startDate.setHours(0, 0, 0));
            this.dateRange.endDate = new Date(this.dateRange.endDate.setHours(23, 59, 59));
            this.countDateRange(this.dateRange.startDate, this.dateRange.endDate);
        },
        getCountLeave() {
            let leaveSearchDTO = {
                employeeId: this.checkId,
                organizationBranchId: this.organizationBranchId,
                organizationId: this.organizationId,
                status: this.radios,
                fromDate: this.dateRange.startDate,
                toDate: this.dateRange.endDate,
            };
            this.$vs.loading();
            this.$crm.post(`/on-leave/count-leave`, leaveSearchDTO).then((response) => {
                this.countLeave = response.data
                this.$vs.loading.close();
            }).catch(() => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: "Có lỗi",
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        getCountLeaveRco() {
            let leaveSearchDTO = {
                employeeId: this.checkId,
                organizationBranchId: this.organizationBranchId,
                organizationId: this.organizationId,
                status: this.radios,
                fromDate: this.dateRange.startDate,
                toDate: this.dateRange.endDate,
            };
            this.$vs.loading();
            this.$crm.post(`/on-leave/find-by-employee-id/${this.checkId}`, leaveSearchDTO).then((response) => {
                this.countLeaveRco = response.data
                this.$vs.loading.close();
            }).catch(() => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: "Có lỗi",
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        buttonBack() {
            this.$router.push(`/user/manage-policy?activeTabs=1`).catch(() => {
            })
        },
    },
    async created() {
        await this.initSrc()
        this.countDateRange(this.dateRange.startDate, this.dateRange.endDate);
    }

}
</script>
<style lang="scss" scoped>
.ag-grid-cell-chip {
    &.vs-chip-success {
        background: rgba(var(--vs-success), .15);
        color: rgba(var(--vs-success), 1) !important;
        font-weight: 500;
    }

    &.vs-chip-warning {
        background: rgba(var(--vs-warning), .15);
        color: rgba(var(--vs-warning), 1) !important;
        font-weight: 500;
    }

    &.vs-chip-danger {
        background: rgba(var(--vs-danger), .15);
        color: rgba(var(--vs-danger), 1) !important;
        font-weight: 500;
    }
}

.numrl {
    font-size: 25px;
    color: green;
    text-align: center;
}

.numr {
    font-size: 25px;
    text-align: center;
}

.tdx {
    text-align: center;
    font-size: 13px;
}

.snp {
    font-size: 12px;
    color: black;
    font-weight: 500;
    text-align: center;
}

.minwwt {
    min-width: 70px !important;
}

.minwwts {
    width: 100px !important;
}

.stdate {
    padding: 6px;
    background: rgba(var(--vs-primary),1);
    border-radius: 10px;
}

.bsty {
    font-size: 12px;
    color: black;
    font-weight: 500;
}

.twentText {
    font-size: 12px;
    color: #b9b9c3;
}

.fontMb {
    font-size: 14px;
}
</style>
